import { FC } from "react";
import { ImportQuickBooksCustomers } from "../../AdminSettings/ImportQuickBooksCustomers/ImportQuickBooksCustomers";

export const ConfigQuickBooksImport: FC = () => {
  return <ImportQuickBooksCustomers />;
};
